import { Button, Icon, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Text as NBText, Skeleton } from 'native-base';
import React from 'react';
import { Pressable, StyleSheet } from 'react-native';

import { ManagementFeeStatus } from '../../../store/rateManagement/constants';

import { Card } from './components/Card';
import { FooterTable } from './components/FooterTable';
import { TableCustomerDetail } from './components/TableCustomerDetail/table';

import { RequestDetailsTypes } from '.';

export const RequestDetailsMobile: React.FC<RequestDetailsTypes.Props> = ({
  onCloseDetails,
  onCancelOrder,
  onSendOrder,
  onSelectTable,
  sentOrder,
  loading,
  error,
  isNeedingAttentionEmpty,
  isValidCustomersEmpty,
  tableSelected,
}) => {
  return (
    <VStack
      justifyContent="space-between"
      padding={Spacing['stack.xxs']}
      flex={1}
      style={styles.view}>
      <HStack pb={Spacing['stack.xxxs']} alignItems="center">
        <Pressable onPress={onCloseDetails}>
          <Icon
            testId="arrow-left-button"
            size="xxs"
            name="ArrowLeft"
            color={Color['brand.primary.principal']}
          />
        </Pressable>
        <Text
          fontWeight={Typography['fontweight.semibold']}
          fontSize={Typography['fontsize.lg']}
          pl={Spacing['inset.nano']}>
          Detalhes da solicitação
        </Text>
      </HStack>

      <Card sentOrderDetail={sentOrder} loading={loading} />

      <HStack justifyContent="space-between" paddingBottom={Spacing['inline.nano']}>
        {!isValidCustomersEmpty && (
          <Button
            width="47%"
            size="md"
            onPress={() => onSelectTable('valid')}
            backgroundColor={
              tableSelected === 'valid'
                ? Color['brand.primary.principal']
                : Color['neutral.lightest']
            }
            variant="tertiary">
            <NBText
              color={tableSelected === 'valid' ? Color['neutral.white'] : Color['neutral.dark']}>
              Clientes validados ({sentOrder?.validCustomerTotal})
            </NBText>
          </Button>
        )}

        {!isNeedingAttentionEmpty && (
          <Button
            width="47%"
            onPress={() => onSelectTable('requiresAttention')}
            backgroundColor={
              tableSelected === 'requiresAttention'
                ? Color['brand.primary.principal']
                : Color['neutral.lightest']
            }
            variant="tertiary">
            <NBText
              color={
                tableSelected === 'requiresAttention'
                  ? Color['neutral.white']
                  : Color['neutral.dark']
              }>
              Clientes inválidos ({sentOrder?.invalidCustomerTotal})
            </NBText>
          </Button>
        )}
      </HStack>

      {tableSelected === 'requiresAttention' && (
        <>
          {loading ? (
            <Skeleton
              marginBottom={Spacing['inline.nano']}
              testID="test-skeleton"
              borderRadius="sm"
              height="30px"
            />
          ) : (
            <HStack
              testID="warning-container"
              backgroundColor="rgba(254, 225, 178, 0.4)"
              borderRadius="8px"
              mt={Spacing['inline.nano']}
              mb={Spacing['inline.xxxs']}
              space="6px"
              alignItems="center"
              p="8px">
              <Icon
                testId="warning-icon"
                name="Warning"
                size="xxs"
                color={Color['feedback.attention.default']}
              />
              <Text
                isLoading={loading}
                color="neutral.black"
                fontSize={Typography['fontsize.xs']}
                variant="regular">
                <Text isLoading={loading} fontWeight={Typography['fontweight.semibold']}>
                  Atenção:
                </Text>{' '}
                Clientes inválidos não serão enviados.
              </Text>
            </HStack>
          )}
        </>
      )}

      <TableCustomerDetail
        sentOrder={sentOrder}
        tableSelected={tableSelected}
        loading={loading}
        error={error}
      />

      {sentOrder?.managementFeeStatusNormalized === ManagementFeeStatus.Processed && (
        <FooterTable onCancel={onCancelOrder} onSend={onSendOrder} />
      )}
    </VStack>
  );
};

const styles = StyleSheet.create({
  view: {
    backgroundColor: '#F9F9F9',
  },
});
